import { Box } from "@mui/material";

const VideoCard = ({ videoUrl, autoplay = true, muted = true, ...props }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
      borderRadius={4}
    >
      <iframe
        style={{
          border: "none",
          borderRadius: "8px",
        }}
        width="300"
        height="533"
        src={videoUrl}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        autoPlay={autoplay}
        muted={muted}
        {...props}
      ></iframe>
    </Box>
  );
};

export default VideoCard;
